/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AutocompleteAddressResponseAddresses,
    AutocompleteAddressResponseAddressesFromJSON,
    AutocompleteAddressResponseAddressesFromJSONTyped,
    AutocompleteAddressResponseAddressesToJSON,
} from './';

/**
 * 
 * @export
 * @interface AutocompleteAddressResponse
 */
export interface AutocompleteAddressResponse {
    /**
     * 
     * @type {Array<AutocompleteAddressResponseAddresses>}
     * @memberof AutocompleteAddressResponse
     */
    addresses: Array<AutocompleteAddressResponseAddresses>;
}

export function AutocompleteAddressResponseFromJSON(json: any): AutocompleteAddressResponse {
    return AutocompleteAddressResponseFromJSONTyped(json, false);
}

export function AutocompleteAddressResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutocompleteAddressResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'addresses': ((json['addresses'] as Array<any>).map(AutocompleteAddressResponseAddressesFromJSON)),
    };
}

export function AutocompleteAddressResponseToJSON(value?: AutocompleteAddressResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'addresses': ((value.addresses as Array<any>).map(AutocompleteAddressResponseAddressesToJSON)),
    };
}


